import axios from 'axios'
// 创建一个新的axios实例
console.log(process.env.API_URL)
const request = axios.create({
    baseURL: process.env.API_URL, // 请求基地址
    timeout: 10000 // 超时时间
})

export default request



// WEBPACK FOOTER //
// ./src/api/index.js